import { Enums } from "./../common/enums";
import { Message } from "../common/message";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import _ from "lodash";

import {
  MatDialog,
  NativeDateAdapter,
  DateAdapter,
  MAT_DATE_FORMATS,
} from "@angular/material";
import { AppDateAdapter, APP_DATE_FORMATS } from "./date.adapter";

import { PowertrainService } from "../services/powertrain.service";
import { forkJoin } from "rxjs";
import { QaVisit } from "../models/qavisit";

let ELEMENT_DATA = [];
import { QavisitnotacceptedpointsService } from "./../services/qavisitnotacceptedpoints.service";
import { MessageService } from "../services/message.service";
import { QavisitService } from "../services/qavisit.service";

@Component({
  selector: "app-qavisitreportnotacceptedpoints",
  templateUrl: "./qavisitreportnotacceptedpoints.component.html",
  styleUrls: ["./qavisitreportnotacceptedpoints.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: AppDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS,
    },
  ],
})
export class QavisitreportnotacceptedpointsComponent implements OnInit {
  noMoreData: boolean = false;
  isDataLoaded: boolean = false;
  submitted = false;
  success = false;
  ELEMENT_DATA: any[] = [];
  visitColumns: string[] = [
    "SN",
    "trainno",
    "point",
    "pointType",
    "powertrain",
    "engineType",
    "date",
  ];
  displayedColumns: string[];
  dataSource = new MatTableDataSource();
  isFormDisplay: boolean = false;
  isAddNew: boolean = true;
  powerTrains: any;
  engines: any;
  troubleshooting: any;
  troubleshootingbox: any;
  troubleShootingType = Enums.troubhleShootingType;
  resource: QaVisit = new QaVisit();
  searchObject: any = {
    powerCoach: null,
    dateFrom: null,
    dateTo: null,
    pointType: null,
    trainNo: null,
  };
  searchedEngines: any;
  searchedList: any;
  pageIndex: number = 0;
  pageSize: number = 25;
  totalCount: number = 0;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private service: QavisitnotacceptedpointsService,
    private qaVisitService: QavisitService,
    private ptService: PowertrainService,
    private msg: MessageService
  ) {}

  ngOnInit() {
    this.initData();
    this.getTableColumns();
  }

  initData() {
    forkJoin([this.getPowertrains()]).subscribe(
      (results: any) => {
        this.isDataLoaded = true;

        if (!results) return;

        if (results[0] && results[0].length) {
          this.powerTrains = this.powerTrains.concat(results[0]);
        }
      },
      (err: any) => {
        this.msg.alert(Message.ERROR_LOAD_INIT_DATA);
      }
    );
  }

  getPowertrains() {
    this.powerTrains = [];
    this.engines = [];
    return this.ptService.getAll();
  }

  clearDates() {
    this.searchObject.dateFrom = null;
    this.searchObject.dateTo = null;
  }

  getMoreData() {
    this.service
      .getAllResources(
        this.searchObject.powerCoach,
        ELEMENT_DATA.length,
        25,
        this.searchObject.dateFrom,
        this.searchObject.dateTo
      )
      .subscribe((result: any) => {
        //fetch visits
        if (result && result.length) {
          if (result.length < 25) this.noMoreData = true;
          ELEMENT_DATA = ELEMENT_DATA.concat(result);
          this.ELEMENT_DATA = ELEMENT_DATA;
          this.updateDataSource();
        } else {
          this.noMoreData = true;
          this.updateDataSource();
        }
      });
  }

  //serach
  searchByPowerCoach(powerCoach) {
    //this.searchedList = [];
    if (powerCoach && powerCoach != "null") {
      for (let obj of this.powerTrains) {
        if (obj.id == powerCoach) {
          if (obj && obj.motors && obj.motors.length) {
            this.searchedEngines = obj.motors;
            return;
          } else {
            this.searchedEngines = [];
            return;
          }
        }
      }
    } else {
      this.searchedEngines = [];
    }
  }

  ///////////////////////////init data
  getTableColumns() {
    this.displayedColumns = this.visitColumns;
  }

  updateDataSource(list?: any) {
    if (list) {
      this.dataSource = new MatTableDataSource<any>(list);
      this.dataSource.paginator = this.paginator;
      return;
    }

    if (ELEMENT_DATA && ELEMENT_DATA.length) {
      this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    } else {
      this.dataSource = new MatTableDataSource<any>([]);
    }
    this.dataSource.paginator = this.paginator;
  }

  search() {
    this.noMoreData = false;
    forkJoin([this.getResources(), this.getVisitCount()]).subscribe(
      (results: any) => {
        //fetch visits
        if (results[0] && results[0].length) {
          if (results[0].length < 25) this.noMoreData = true;
          ELEMENT_DATA = [];
          ELEMENT_DATA = ELEMENT_DATA.concat(results[0]);
          this.ELEMENT_DATA = ELEMENT_DATA;
          this.updateDataSource();
        } else {
          this.noMoreData = true;
          ELEMENT_DATA = [];
          this.ELEMENT_DATA = ELEMENT_DATA;
          this.updateDataSource();
        }
        this.totalCount = results[1].count;
      },
      (err: any) => {
        this.msg.alert(Message.ERROR_LOAD_INIT_DATA);
      }
    );
  }

  getVisitCount() {
    return this.service.getAllResourcesCount(
      this.searchObject.powerCoach,
      this.searchObject.dateFrom,
      this.searchObject.dateTo,
      this.searchObject.pointType == 100 ? "BOX" : this.searchObject.pointType,
      this.searchObject.trainNo
    );
  }

  getResources() {
    ELEMENT_DATA = [];
    this.ELEMENT_DATA = ELEMENT_DATA;
    return this.service.getAllResources(
      this.searchObject.powerCoach,
      ELEMENT_DATA.length,
      25,
      this.searchObject.dateFrom,
      this.searchObject.dateTo,
      this.searchObject.pointType == 100 ? "BOX" : this.searchObject.pointType,
      this.searchObject.trainNo
    );
  }

  getIndex(element: QaVisit) {
    const i = _.findIndex(ELEMENT_DATA, element);
    return i + 1;
  }

  getPointType(t) {
    let pointTypeLabel = "";
    switch (t) {
      case "BOX":
        pointTypeLabel = "اعمال الصندوق";
        break;

      case "1":
        pointTypeLabel = "كمبيوتر";
        break;

      case "2":
        pointTypeLabel = "ميكانيكا وكهرباء";
        break;

      case "3":
        pointTypeLabel = "ميكانيكا";
        break;

      case "4":
        pointTypeLabel = "كهرباء";
        break;

      default:
        pointTypeLabel = "";
        break;
    }

    return pointTypeLabel;
  }

  runOldData() {
    //get all qa visits
    this.qaVisitService.getAll().subscribe((result: any) => {
      for (let ele of result) {
        this.saveQAVisitNotAcceptedPoints(ele);
      }
    });
  }

  saveQAVisitNotAcceptedPoints(resource: any) {
    if (!resource.troubleshooting || !resource.troubleshootingbox) return;
    let notAcceptedPoints = [];
    if (resource.troubleshooting && resource.troubleshooting.length) {
      for (let item of resource.troubleshooting) {
        if (item.engine1status == 0) {
          notAcceptedPoints.push({
            trainno: resource.trainno,
            point: item.name,
            pointId: item.id,
            pointType: item.cat,
            powercoach: resource.powertrain ? resource.powertrain.code : "1",
            powercoachId: resource.powertrainId,
            engineId: resource.engine1,
            engineType: "1",
            date: resource.date,
            qavisitId: resource.id,
          });
        }
        if (item.engine2status == 0) {
          notAcceptedPoints.push({
            trainno: resource.trainno,
            point: item.name,
            pointId: item.id,
            pointType: item.cat,
            powercoach: resource.powertrain ? resource.powertrain.code : "1",
            powercoachId: resource.powertrainId,
            engineId: resource.engine2,
            engineType: "2",
            date: resource.date,
            qavisitId: resource.id,
          });
        }
      }
    }
    if (resource.troubleshootingbox && resource.troubleshootingbox.length) {
      for (let item of resource.troubleshootingbox) {
        if (item.status == 0) {
          notAcceptedPoints.push({
            trainno: resource.trainno,
            point: `${item.name} | ${item.desc}`,
            pointId: item.id,
            pointType: "BOX",
            powercoach: resource.powertrain ? resource.powertrain.code : "1",
            powercoachId: resource.powertrainId,
            engineId: "",
            engineType: "",
            date: resource.date,
            qavisitId: resource.id,
          });
        }
      }
    }

    if (notAcceptedPoints.length)
      this.service.create(notAcceptedPoints).subscribe(() => {
        console.log("--");
      });
  }
}
